var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallDrama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33329 9.16667H8.34163M11.6666 5H11.675M15 5H15.0083M5.41663 10.9166H5.42496M14.5 8.25002C13.8334 8.91669 12.8334 8.91669 12.1667 8.25002M8.41679 5.91665C7.50012 5.99998 6.41679 6.41665 5.00012 7.16665C2.08345 8.83331 1.08345 10.4166 1.91679 11.8333C5.66679 18.3333 9.83345 18.8333 11.2501 18C12.0001 17.5833 12.8335 16.25 12.8335 14.0833M7.58337 13.75C7.83337 12.8334 8.75004 12.3334 9.58337 12.5834M18.3333 4.16667C18.3333 11.6667 15 14.1667 13.3333 14.1667C11.6666 14.1667 8.33329 11.6667 8.33329 4.16667C8.33329 2.5 9.99996 1.66667 13.3333 1.66667C16.6666 1.66667 18.3333 2.5 18.3333 4.16667Z",
    stroke: "#4B286D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallDrama);
export default __webpack_public_path__ + "static/media/small-drama.2a159cdb6924bfda18311e93de5ac66a.svg";
export { ForwardRef as ReactComponent };